module.exports = "/_next/static/images/dakisolatie-acfbfcf2d23554382fe4139875ccc651.jpg";